import { basicFilterInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { rateSweepActionTypes } from '../actions/actionTypes';

export const FILTER_REDUCER_NAME = 'RateSweepList';

const updateFilterConfig = (state, action) => {
  const selectedFilter = (action.data && action.data.selectedItem) || null;
  if (action.data) {
    if (action.data.systemDefault) {
      return {
        ...state,
        selectedFilter,
        systemDefaultFilter: action.data.systemDefault || null,
        userDefaultFilter: action.data.userDefault || null,
      };
    }
    if (action.data.userDefault === null || action.data.userDefault) {
      return {
        ...state,
        selectedFilter,
        userDefaultFilter: action.data.userDefault,
      };
    }
  }
  return {
    ...state,
    selectedFilter,
  };
};

const updateFilterOption = (state, action) => ({
  ...state,
  listGroupBy: action.data ? action.data.detail.groupByParameters : null,
  listParamOptions: action.data ? action.data.detail.parameters : null,
  listSortOptions: action.data ? action.data.detail.sortOptions : null,
  listColumnOrder: action.data ? action.data.detail.columnOrders : null,
  selectedFilter: action.data ? action.data : null,
});

const logListRequest = (state, action) => ({
  ...state,
  listRequest: action.data ? action.data : state.listRequest,
  listRequestedOn: new Date(),
  loading: true,
});
const resetServerValue = (state, action) => ({
  ...state,
  serverRequestError: action.data && action.data.serverRequestError,
  loading: false,
});

const getEditItemDetailsResponse = (state, action) => ({
  ...state,
  getEditItemDetails: action.data,
});

function RateSweepList1(state, action = null) {
  switch (action.type) {
    case rateSweepActionTypes.UPDATE_SWEEP_FILTER_CONFIG:
      return updateFilterConfig(state, action);
    case rateSweepActionTypes.REMOVE_USER_DEFAULT_FILTER:
      return {
        ...state,
        userDefaultFilter: null,
      };
    case rateSweepActionTypes.UPDATE_SWEEP_TABLE_CONFIGURATION:
      return updateFilterOption(state, action);
    case rateSweepActionTypes.LOG_LIST_REQUEST:
      return logListRequest(state, action);
    case rateSweepActionTypes.GET_SWEEP_BY_ID_RESPONSE:
      return getEditItemDetailsResponse(state, action);
    case rateSweepActionTypes.GET_SWEEP_LIST_ERROR:
      return {
        ...state,
        listRequestError: action.data,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case rateSweepActionTypes.GET_SWEEP_LIST_RESPONSE:
      return {
        ...state,
        listData: action.data,
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case rateSweepActionTypes.GET_SWEEP_CLONE_LIST_RESPONSE:
      return {
        ...state,
        cloneListData: {
          page: 1,
          totalRows: 2,
          pageSize: 10,
          dataCap: 1000,
          locale: 'en',
          isDistinct: false,
          lookUps: [],
          data: [
            ...action?.data?.item1,
          ],
        },
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
        cloneflag: action?.data?.item2,
      };
    case rateSweepActionTypes.GET_SWEEP_CLONE_LIST_RESPONSE_RESET:
      return {
        ...state,
        cloneListData: null,
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    default:
      return null;
  }
}
function RateSweepList2(state, action = null) {
  switch (action.type) {
    case rateSweepActionTypes.RESET_STORE:
      return {
        ...state,
        listData: null,
        listRequestError: null,
        listRequestProcessedOn: null,
        serverRequestError: null,
        getEditItemDetails: null,
        loading: false,
      };
    case rateSweepActionTypes.RESET_SERVER_VALUE:
      return resetServerValue(state, action);
    case rateSweepActionTypes.RESET_UPSERT_ERROR:
      return {
        ...state,
        upsertRequestError: [],
      };
    case rateSweepActionTypes.RESET_UPSERT_VALUE:
      return {
        ...state,
        upsertRequest: action.data.upsertRequest,
        upsertRequestError: action.data.upsertRequestError,
        upsertRequestedOn: action.data.upsertRequestedOn,
        upsertRequestProcessedOn: action.data.upsertRequestProcessedOn,
        upsertData: action.data.upsertData,
        loading: false,
      };
    case rateSweepActionTypes.RESET_DELETE_VALUE:
      return {
        ...state,
        deleteRequest: action.data.deleteRequest,
        deleteRequestError: action.data.deleteRequestError,
        deleteRequestedOn: action.data.deleteRequestedOn,
        deleteRequestProcessedOn: action.data.deleteRequestProcessedOn,
        deleteData: action.data.deleteData,
      };
    case rateSweepActionTypes.SET_SWEEP_DETAILS_RESPONSE:
      return {
        ...state,
        subModuledetails: action.data,
      };
    case rateSweepActionTypes.RESET_RS_LOOKUPDATA:
      return {
        ...state,
        pageLevelLookupData: action.data,
      };
    case commonTypes.RESETSTORE:
      return basicFilterInitialState;
    default:
      return null;
  }
}
const RateSweepList = (state = { ...basicFilterInitialState }, action = null) => {
  const rs1 = RateSweepList1(state, action);
  if (rs1 !== null) {
    return rs1;
  }
  const rs2 = RateSweepList2(state, action);
  if (rs2 !== null) {
    return rs2;
  }
  return state;
};

export default RateSweepList;
